import transform from './transform'
import constants from '../constants'
import { APIClient, serializeFormdata } from 'DVWebNodeUtils';


const ENRICH_MOCK_URL = 'https://s3.us-east-2.amazonaws.com/dv-web-storefront-mocks-poc/storefrontEnrichItemsResponse.json'
const LIVE_CHANNEL_UPDATE_URL = 'https://s3.us-east-2.amazonaws.com/dv-web-storefront-mocks-poc/liveChannelsUpdate.json'

export default function fetch(url: string, isUsingMock: boolean = false, method?: string, body?: string) {
  const options: { [key: string]: any } = isUsingMock ? {} : { credentials: 'include' }
  if (method === 'POST') {
    options.method = method
    options.headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'x-requested-with': 'XMLHttpRequest'
    }
    if (body) {
      options.body = serializeFormdata(body)
    }
  }

  const enrichMockURL = isUsingMock && url.indexOf(constants.ENRICH_API_ENDPOINT) >= 0 &&
    ENRICH_MOCK_URL
  const liveChUpdateMockURL = isUsingMock &&
    url.indexOf(constants.liveChannelsRefresh.LIVECHANNELS_UPDATE_API_ENDPOINT) >= 0 &&
    LIVE_CHANNEL_UPDATE_URL

  const requestUrl = enrichMockURL || liveChUpdateMockURL || url
  const api = new APIClient

  return api.call(requestUrl, options)
    .then((jsonResponse: { [key: string]: any }) => transform(jsonResponse))
}
